import { I18n } from '@aws-amplify/core';
import type { ColumnsType } from 'antd/lib/table';

import { formatDate } from '../utils';
import { FileForCustomReport } from '@/components/ui/Inputs/types/response/file';

const LOAD_DATE_COLUMN_WIDTH = '14%';

type TlidCellRenderer = (file: FileForCustomReport) => JSX.Element;
type FileColumns = ColumnsType<FileForCustomReport>;

export function buildFileColumns(renderTlidCell: TlidCellRenderer): FileColumns {
	const columns: FileColumns = [
		{
			title: I18n.get('File'),
			dataIndex: 'original_name',
			key: 'original_name',
			align: 'center',
			ellipsis: true
		},
		{
			title: I18n.get('Load date'),
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center',
			width: LOAD_DATE_COLUMN_WIDTH,
			render: formatDate
		},
		{
			title: I18n.get('TLID'),
			key: 'tlid',
			align: 'center',
			render: (_value: string, file: FileForCustomReport) => renderTlidCell(file)
		}
	];

	return columns;
}
